module.exports = __webpack_public_path__ + "static/media/pt.12f9ecc6.svg";